import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaEye, FaRegFileExcel } from 'react-icons/fa6';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import AddActivite from './AddActivite';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';
import Select from 'react-select';
import NumberFormat from '../../components/NumberFormat';
import { FaBan, FaCheck, FaCircle } from 'react-icons/fa';


const Activites = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [activites, setActivites] = useState([]);
    const [showAddActivite, setShowAddActivite] = useState(false);
    const [showActivite, setShowActivite] = useState(false);
    const [caisseCentrales, setCaisseCenrales] = useState([]);
    const [selectedCaisseCentrale, setSelectedCaisseCentrale] = useState(null);
    const [inputValueCaisseCentrale, setValueCaisseCentrale] = useState('');
    const [selectedActivite, setSelectedActivite] = useState(null);

    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        caisseCentrale: '',

    });
    const navigate = useNavigate();

    const supprimer = (activite) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/activite/' + activite.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getActivites();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    const handleInputChangeCaisseCentrale = value => {
        setValueCaisseCentrale(value);
    };

    // handle selection


    // handle selection
    const handleChangeCaisseCentrale = value => {
        setSelectedCaisseCentrale(value);
        setReq({ ...req, caisseCentrale: value.id });

    }

    useEffect(() => {
        if (user.role != null && (user.role.name === 'admin' || user.role.name === 'controleur')) {
            getCaisseCentrales();
        }
    }, [])

    const getCaisseCentrales = () => {
        axiosClient.get('/caisseCentrales')
            .then((data) => {
                setCaisseCenrales(data.data.caisseCentrales);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const closeAddActivite = () => {
        setShowAddActivite(false);
    }
    const closeShowActivite = () => {
        setShowActivite(false);
        setSelectedActivite(null);
    }
    const getActivites = () => {
        setLoading(true);
        axiosClient.get('/activites?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin + '&caisseCentrale=' + req.caisseCentrale)
            .then(response => {
                setActivites(response.data.activites);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const valider = (activite) => {
        axiosClient.put('/validerActivite/' + activite.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const annuler = (activite) => {
        axiosClient.put('/annulerActivite/' + activite.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header title="Activites" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
                <Input label="Date debut" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
                <Input label="Date fin" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />
                {user.role && (user.role.name === 'admin' || user.role.name === 'controleur') ?
                    <div className="flex-col w-full">
                        <label className="block text-sm font-medium leading-6 text-gray-900">Caisse Centrale <span className='text-red-500'> *</span></label>
                        <Select className='mt-1 outline-1 ' placeholder="Caisse Centrale" cacheOptions defaultOptions value={selectedCaisseCentrale} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={caisseCentrales} onInputChange={handleInputChangeCaisseCentrale} onChange={handleChangeCaisseCentrale} />
                    </div>
                    :
                    <></>
                }
                <div className=' flex gap-2 mt-8'>
                    <Button onClick={() => getActivites()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                    <DownloadTableExcel
                        filename="Activites"
                        sheet="activites"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />
                    </DownloadTableExcel>
                </div>
            </div>
            {
                user.role && user.role.name === 'ccaissier' ? <div className="flex my-4">
                    <Button onClick={() => setShowAddActivite(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                </div>
                    :
                    <></>
            }
            <div className="flex my-2">
                <h1 className='text-red-500 font-bold'>Total: <NumberFormat valeur={activites.reduce((n, { montant }) => n + parseFloat(montant), 0)} /> MRU</h1>
                <h1 className='text-yellow-600-500 font-bold'>Total Commissions: <NumberFormat valeur={activites.reduce((n, { montantCommission }) => n + parseFloat(montantCommission), 0)} /> MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            
                            <th>Date</th>
                            <th>Caisse</th>
                            <th>Total Paiement</th>
                            <th>Total Commission</th>
                            <th>État</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="7"><Loading /></td></tr></tbody> :
                        <tbody>
                            {activites.map(o => (
                                <tr key={o.id}>
                                    
                                    <td>{o.dateActivite}</td>
                                    <td>{o.caisse.nom}</td>
                                    <td>{o.totalPaiement}</td>
                                    <td>{o.totalCommission}</td>
                                    {
                                        o.valide === false ?
                                            <div className='flex justify-center items-center text-lg text-orange-500'>
                                                <FaCircle />
                                            </div>
                                            :
                                            <div className='flex justify-center content-center items-center text-lg text-lime-500'>
                                                <FaCircle />
                                            </div>
                                    }
                                    <td>
                                        <div className="flex gap-2">
                                            {user.role && (user.role.name === 'admin' || user.role.name === 'controleur') ?
                                                <>
                                                    {
                                                        o.valide === false ?
                                                            <ActionButton onClick={() => { valider(o) }} color="bg-green-500" icon={<FaCheck />} textColor="text-white" title="Valider" />
                                                            :
                                                            <>
                                                                {user.role && (user.role.name === 'admin' ) ?
                                                                    <ActionButton onClick={() => { annuler(o) }} color="bg-yellow-500" icon={<FaBan />} textColor="text-white" title="Annuler" />
                                                                    :
                                                                    <></>
                                                                }
                                                            </>
                                                    }
                                                </>
                                                :
                                                <></>

                                            }
                                            <ActionButton onClick={() => {
                                                setSelectedActivite(o);
                                                setShowActivite(true);
                                            }} color="bg-blue-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                            {user.role && (user.role.name === 'admin' || user.role.name === 'controleur') ?
                                                <>
                                                    {o.valide === false ?
                                                        <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                                                        :
                                                        <></>
                                                    }
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    }
                </table>
            </div>
            {
                showAddActivite ? <AddActivite onClose={closeAddActivite} /> : <></>
            }
            {/* {
                showActivite ? <ShowActivite activite={selectedActivite} onClose={closeShowActivite} /> : <></>
            } */}

        </>
    )
}

export default Activites